export const TEXTS = {
  TITLE: 'Delegated Authority',
  SUBTITLE: 'Customize Authority levels and Override Rules.',
  ENABLE_TOGGLE_LABEL: 'Enable Delegated Authority',

  SUBTAB_LEVELS: 'Levels',
  SUBTAB_OVERRIDE_RULES: 'Override Rules',

  AUTHORITY_LEVELS_SECTION_TITLE: 'Authority Levels',
  ROUND_ROBIN_TOGGLE_LABEL: 'Round-robin approver selection',
  ROUND_ROBIN_TOGGLE_HELP:
    'When on, approval requests rotate across eligible approvers at the matched authority level. When off, requests route to the requester’s supervisor.',
  ADD_LEVEL: 'Add Authority Level',
  EDIT_LEVEL: 'Edit Authority Level',
  CREATE_LEVEL: 'Create Authority Level',
  DELETE_LEVEL: 'Delete',
  DELETE_CONFIRM_TITLE: 'Delete authority level?',
  DELETE_CONFIRM_BODY: (name: string): string =>
    `Are you sure you want to delete authority level "${name}"? This cannot be undone.`,
  EMPTY_STATE: 'No authority levels yet.',
  UNLIMITED: 'Unlimited',

  OVERRIDE_RULES_SECTION_TITLE: 'Override Rules',
  OVERRIDE_RULES_BANNER: 'Rules are evaluated in order — the first matching rule applies.',
  ADD_OVERRIDE_RULE: 'Add Override Rule',
  EDIT_OVERRIDE_RULE: 'Edit Override Rule',
  CREATE_OVERRIDE_RULE: 'Create Override Rule',
  DELETE_OVERRIDE_RULE_CONFIRM_TITLE: 'Delete override rule?',
  DELETE_OVERRIDE_RULE_CONFIRM_BODY: (name: string): string =>
    `Are you sure you want to delete override rule "${name}"? This cannot be undone.`,
  OVERRIDE_RULES_EMPTY_STATE: 'No override rules yet.',
  COLUMN_RULE_NAME: 'Name',
  COLUMN_ENABLED: 'Enabled',
  COLUMN_PRIORITY: 'Priority',
  COLUMN_LOB: 'LOB',
  COLUMN_SUB_ORGANIZATIONS: 'Sub Organizations',
  SCOPE_ALL: 'All',
  MOVE_RULE_UP_LABEL: (name: string): string => `Move ${name} up`,
  MOVE_RULE_DOWN_LABEL: (name: string): string => `Move ${name} down`,
  FIELD_DISPLAY_NAME: 'Name',
  FIELD_DISPLAY_NAME_REQUIRED: 'Name is required',
  SECTION_SCOPE: 'Scope',
  FIELD_SUB_ORGANIZATIONS: 'Sub Organizations',
  FIELD_LOBS: 'Lines of Business',
  SCOPE_CHANGE_BANNER_TITLE: 'Please Note',
  SCOPE_CHANGE_BANNER: 'Editing the sub organizations or lines of business will clear all conditions.',
  SECTION_PER_LEVEL_OVERRIDES: 'Per-level Overrides',
  PER_LEVEL_OVERRIDES_HELP: 'For each level you select, set the limit fields you want to override.',
  OVERRIDE_LEVEL_TOGGLE: 'Override',
  VALIDATION_OVERRIDES_REQUIRED: 'At least one level override is required.',
  VALIDATION_SUB_ORGANIZATION_REQUIRED: 'At least one sub organization must be selected',
  VALIDATION_LOB_REQUIRED: 'At least one line of business must be selected',

  SAVE: 'Save',
  CANCEL: 'Cancel',

  COLUMN_NAME: 'Name',
  COLUMN_KEY: 'Key',
  COLUMN_USERS: 'Assigned Users',
  COLUMN_INDEMNITY_PAYMENTS: 'Indemnity Payments',
  COLUMN_EXPENSE_PAYMENTS: 'Expense Payments',
  COLUMN_INDEMNITY_RESERVES: 'Indemnity Reserves',
  COLUMN_EXPENSE_RESERVES: 'Expense Reserves',
  COLUMN_PAYMENTS: 'Payments',
  COLUMN_RESERVES: 'Reserves',

  FIELD_NAME: 'Name',
  FIELD_KEY: 'Key',
  FIELD_KEY_HELP: 'Stable identifier. Cannot be changed after creation.',
  FIELD_INDEMNITY: 'Indemnity',
  FIELD_EXPENSES: 'Expenses',
  FIELD_PAYMENTS: 'Payments',
  FIELD_RESERVES: 'Reserves',
  SECTION_PAYMENTS_LIMITS: 'Payments Limits',
  SECTION_RESERVES_LIMITS: 'Reserves Limits',
  FULL_AUTHORITY: 'Full Authority',

  VALIDATION_REQUIRED: 'Required',
  VALIDATION_NAME_REQUIRED: 'Name is required',
  VALIDATION_KEY_REQUIRED: 'Key is required',
  VALIDATION_KEY_FORMAT: 'Lowercase letters, numbers, and underscores only. Must start with a letter.',
  VALIDATION_LIMIT_NUMBER: 'Must be a whole number',
  VALIDATION_LIMIT_MIN: 'Must be -1 or a non-negative whole number',

  FIELD_AUTHORITY_LEVEL: 'Authority Level',
  AUTHORITY_LEVEL_NONE: 'None',
  COLUMN_AUTHORITY_LEVEL: 'Authority Level',
  CSV_HEADER_AUTHORITY_LEVEL: 'Authority Level',
} as const;
